import { Component, Input, OnInit } from '@angular/core';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { faEllipsisH } from '@fortawesome/pro-solid-svg-icons';
import { Store } from '@ngxs/store';
import _ from 'lodash';
import { emailContactToString, formatEmailReceivers } from 'src/app/helper/emailingHelpers';
import { MessageActions } from 'src/app/samwebDescription/samweb/messages/MessageActions';
import { Email } from 'src/app/store/samwin/email/email-behaviour/email';
import { MessageInfo } from 'src/app/store/samwin/samwin-mail-list/message-info';
import { MailingFolderEnum } from 'src/app/store/samwin/samwin-skills/mailing-folders-enum';
import { Attachment } from 'src/generated/swagger';

@Component({
   selector: 'samweb-email-reader-window',
   templateUrl: './email-reader-window.component.html',
   styleUrls: ['./email-reader-window.component.scss'],
})
export class EmailReaderWindowComponent implements OnInit {
   public static actionDisplayLength = 4;

   @Input()
   public email: Email;

   @Input()
   public messageInfo: MessageInfo;

   @Input()
   public attachments: Attachment[];

   public skillTreeIcon: IconDefinition;

   public ellipsisIcon: IconDefinition = faEllipsisH;

   public displayAllActions = false;

   public standardActionIds: string[];

   public actionIds: string[];

   public receivers: string[];

   public receiver: string;

   public actionDisplayLength = EmailReaderWindowComponent.actionDisplayLength;

   public isInbox: boolean;

   constructor(public store: Store) {}

   ngOnInit() {
      this.setActionsForWindow();

      this.isInbox = this.messageInfo.group === MailingFolderEnum.INBOX.name;

      // format receivers in case of canceling an edit action
      const emailTo = formatEmailReceivers(emailContactToString(this.email?.to) ?? '');

      this.receivers = _.split(emailTo, ';');
      this.receiver = this.receivers.join(', ');

      this.skillTreeIcon = MailingFolderEnum[this.messageInfo.group].icon;
   }

   executeAction(actionId: string) {
      MessageActions[actionId].executeAction$(this.store, this.messageInfo);
   }

   setActionsForWindow() {
      this.actionIds = _(MessageActions.getValues())
         .map((action) => action.value)
         .value();

      if (this.messageInfo.group !== MailingFolderEnum.INBOX.name) {
         this.actionIds = this.actionIds.filter(
            (action) =>
               action !== MessageActions.REPLY.enumName &&
               action !== MessageActions.REPLY_ALL.enumName &&
               action !== MessageActions.FORWARD.enumName &&
               action !== MessageActions.REQUEUE.enumName &&
               action !== MessageActions.PARK_AGENT.enumName &&
               action !== MessageActions.PARK_SKILL.enumName
         );
         if (this.messageInfo.group === MailingFolderEnum.COMPLETED.name) {
            this.actionIds = this.actionIds.filter((action) => action !== MessageActions.COMPLETE.enumName);
         }
         if (this.messageInfo.group === MailingFolderEnum.TRACKING.name) {
            this.actionIds = this.actionIds.filter((action) => action !== MessageActions.TRACK.enumName);
         }
         if (this.messageInfo.group === MailingFolderEnum.DELETED.name) {
            this.actionIds = this.actionIds.filter((action) => action !== MessageActions.DELETE.enumName);
         }
         if (this.messageInfo.group === MailingFolderEnum.SENT.name || this.messageInfo.group === MailingFolderEnum.OUTBOX.name) {
            this.actionIds = [];
         }
      } else {
         this.actionIds = this.actionIds.filter((action) => action !== MessageActions.UNDO.enumName);
      }

      if (this.messageInfo.group === MailingFolderEnum.INBOX.name) {
         this.standardActionIds = [
            MessageActions.REPLY.enumName,
            MessageActions.REPLY_ALL.enumName,
            MessageActions.FORWARD.enumName,
            MessageActions.COMPLETE.enumName,
         ];
      } else {
         this.standardActionIds = _(this.actionIds).take(EmailReaderWindowComponent.actionDisplayLength).value();
      }
   }

   openDialog() {
      this.displayAllActions = true;
   }

   closeDialog() {
      this.displayAllActions = false;
   }
}
